import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import bgimage from '../../../../images/default_staff.png';
import "react-dropzone-uploader/dist/styles.css";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import staff1 from '../../../../images/staff/member_2.png';
import { Button, Modal, Tooltip, OverlayTrigger, Badge } from 'react-bootstrap';
import document from '../../../../images/doc.png'
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const ViewStaff = (staffData) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const sno = queryParams.get('data');

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [staff, setStaff] = useState(null);
    const imageBaseURL = baseURL.replace('/api', '');


    useEffect(() => {
        fetch(`${baseURL}/managestaff/${sno}`)
            .then((res) => res.json())
            .then((data) => setStaff(data.data));
    }, [sno]);

    const [transfer_data, setTransData] = useState([]);
    const [is_transfer, setIstransfer] = useState(0);
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        if (sno) {
            axios.get(`${baseURL}/managestaff/transfer_staff/${sno}`)
                .then(response => {
                    setTransData(response.data.data);
                    setIstransfer(response.data.is_transfer);
                    setHasFetched(true);
                })
                .catch(error => {
                    console.error('Error fetching staff data!', error);
                    setHasFetched(true);
                });
        }
    }, [sno]);


    const genderOptions = {
        "0": "Male",
        "1": "Female",
        "2": "Others"
    };

    const educationLevelOptions = {
        "0": "10th",
        "1": "12th",
        "2": "Diploma",
        "3": "UG",
        "4": "PG"
    };

    const staffImageUrl = staff && staff.staff_image
        ? `${imageBaseURL}/storage/${staff.staff_image}`
        : bgimage.replace('./', '/');

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [files, setFiles] = useState(null);
    const [hovered, setHovered] = useState(false);

    const containerStyle = {
        position: 'relative',
        width: '100px',
        height: '110px',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transform: hovered ? 'scale(1.05)' : 'scale(1)',
        boxShadow: hovered ? '0 6px 16px rgba(0, 0, 0, 0.25)' : 'none',

    };

    const iconStyle = {
        display: hovered ? 'inline-block' : 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgb(180, 228, 126)',
        borderRadius: '50%',
        padding: '8px',
        transition: 'opacity 0.3s ease',
    };

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles m-1 px-0 py-1 mx-0 mb-4">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>View Staff</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">HR Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-staff'>Manage Staff</Link></li>
                    </ol>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-4 pe-1'>
                    {staff && (
                        <div className='card px-3'>

                            <div className="d-flex justify-content-center w-100 mt-3">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={staffImageUrl} className="d-flex h-175px w-175px p-2" >
                                        <img src={staffImageUrl} style={{ width: "100%" }} alt={staff.employee_name || 'Staff'} className='cursor-pointer' />
                                    </div>
                                </LightGallery>
                            </div>

                            <label className='text-primary text-center fs-4 font-w600 mt-3 mb-2'>{staff.employee_name}</label>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>{staff.manage_staff_type_id === 0 ? 'Branch' : 'Franchise'}</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-solid fa-code-branch fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.manage_staff_type_id === 0 ? 'Branch' : 'Franchise'} - {staff.branch?.branch_name || 'N/A'}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Date of birth</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-solid fa-calendar-days fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.date_of_birth}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Role</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-regular fa-circle-user fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.user_role?.user_role_name || 'N/A'}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Gender</span></Tooltip>} >
                                    <span className='me-3'><i className=' fa fa-venus-mars fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{genderOptions[staff.gender] || 'N/A'}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Email</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-regular fa-envelope fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.mail_id}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Mobile Number</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-solid fa-phone fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.phone_no}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Address</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-solid fa-location-dot fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.address}</span>
                            </div>
                            <div className='fs-6 font-w500 text-black mb-2'>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Pincode</span></Tooltip>} >
                                    <span className='me-3'><i className='fa-solid fa-map-pin fs-5'></i></span>
                                </OverlayTrigger>
                                <span>{staff.pincode}</span>
                            </div>
                            <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Designation Information</label>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Date of Joining</label>
                                    <label className='text-black fs-6 font-w500'>{staff.date_of_joining}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Position</label>
                                    <label className='text-black fs-6 font-w500'>{staff.position}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Department</label>
                                    <label className='text-black fs-6 font-w500'>{staff.department?.department_name || 'N/A'}</label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Salary</label>
                                    <label className='text-black fs-6 font-w500'>
                                        <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                        <span>{staff.salary}</span>
                                    </label>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Job Role</label>
                                    <label className='text-black fs-6 font-w500'>{staff.job_role?.jobrole_name || 'N/A'}</label>
                                </div>
                                <div className='col-lg-6 col-md-12 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Shift Time</label>
                                    <label className='text-black fs-6 font-w500'>{staff.shift_time?.shifttime_name || 'N/A'}</label>
                                </div>
                            </div>

                        </div>
                    )}
                </div>

                <div className='col-lg-8 pe-1'>
                    {staff && (
                        <div className='card px-3'>
                            <label className='mt-3 col-12 text-red fs-4 font-w600 mb-3'>Basic Information</label>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Contact Person</label>
                                    <label className='text-black fs-6 font-w500'>{staff.contact_person}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Educational Level</label>
                                    <label className='text-black fs-6 font-w500'>{educationLevelOptions[staff.education_level] || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Contact Person Phone No</label>
                                    <label className='text-black fs-6 font-w500'>{staff.contact_person_phone_no}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Experience Level</label>
                                    <label className='text-black fs-6 font-w500'>{staff.experience_level === 0 ? 'Fresher' : 'Experience'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Alternate Phone No</label>
                                    <label className='text-black fs-6 font-w500'>{staff.alternate_phone_no || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Work Experience</label>
                                    <label className='text-black fs-6 font-w500'>{staff.work_experience || '-'}</label>
                                </div>
                            </div>
                            <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Bank Information</label>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Bank Name</label>
                                    <label className='text-black fs-6 font-w500'>{staff.bank_name || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Branch Name</label>
                                    <label className='text-black fs-6 font-w500'>{staff.branch_name || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Account Holder Name</label>
                                    <label className='text-black fs-6 font-w500'>{staff.account_holder_name || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Account No</label>
                                    <label className='text-black fs-6 font-w500'>{staff.account_no || '-'}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>IFSC Code</label>
                                    <label className='text-black fs-6 font-w500'>{staff.ifsc_code || '-'}</label>
                                </div>
                            </div>
                            <div className='row mt-3'>
                                <div className='col-lg-12 col-md-12 pe-2'>
                                    <label className="text-gray-800 font-w600 fs-6">Description</label>
                                    <div className="text-black fs-7  px-1 py-3">
                                        <p>&emsp;&emsp;{staff.description}</p>
                                    </div>
                                </div>
                                <div className='col-lg-12 col-md-12 pe-2'>
                                    <label className='text-gray-800 font-w600 fs-6'>Attachment</label>
                                    {/* <div className='card'> */}
                                    <div className="avatar-upload d-flex flex-column align-items-start">
                                        <div className="change position-relative">
                                            <div className="d-flex flex-wrap align-items-center gap-2 px-2 py-2">
                                                {staff.attachments && staff.attachments.length > 0 ? (
                                                    staff.attachments.map((attachment, index) => (
                                                        <div
                                                            key={attachment.id || index}
                                                            style={containerStyle}
                                                            onMouseEnter={() => setHovered(true)}
                                                            onMouseLeave={() => setHovered(false)}
                                                        >
                                                            <img src={`${imageBaseURL}/storage/${attachment.file_path}`} alt="attachment" style={imageStyle} />
                                                            <a href={`${imageBaseURL}/storage/${attachment.file_path}`} download style={iconStyle}>
                                                                <i className="fa-solid fa-download text-black fs-6"></i>
                                                            </a>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div style={containerStyle}>
                                                        <img src={document} alt="No Attachment" style={imageStyle} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    )}
                </div>


                <div className='col-lg-12 pe-1'>
                    {is_transfer === 1 && (
                        <div className='card px-3'>
                            <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Role Transfer Information</label>

                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable mb-3">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                        <th className='min-w-100px'>Date</th>
                                        <th className='min-w-100px'>Past Department / Jobrole</th>
                                        <th className='min-w-100px'>Current Department / Jobrole</th>
                                        <th className='min-w-100px'>Reason</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                                    {transfer_data.length === 0 && hasFetched ? (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted py-2">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {transfer_data.map((data, index) => (
                                                <tr>
                                                    <td>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Start Date</span></Tooltip>} >
                                                            <div className='text-success font-w600 fs-7'>{data.start_date}</div>
                                                        </OverlayTrigger>
                                                        <div className='d-block mt-1'>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>End Date</span></Tooltip>} >
                                                                <label className='text-danger font-w600 fs-7'>{data.end_date}</label>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.past_dept_name}</div>
                                                        <div className='d-block'>
                                                            <div className='text-dark font-w600 fs-8'>{data.past_job_role}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.current_dept_name}</div>
                                                        <div className='d-block'>
                                                            <div className='text-dark font-w600 fs-8'>{data.current_job_role}</div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.reason ? data.reason : '-'}</div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>

                        </div>
                    )}
                </div>
            </div>
        </>
    )


}
export default ViewStaff;